import styled from 'styled-components';

export const InclusionCont = styled.div`
    border-radius: 0.4rem;
    background-color: #ffffff;
    margin: ${p => p.margin ? p.margin : ''};
`;
export const InclusionHeader = styled.div`
    padding: 2.3rem 3rem 1rem 3rem;
    border-bottom: 0.1rem #e5edf6 solid;
    h3{
        font-family: 'Rubik';
        font-size: 1.8rem;
        line-height: 2.4rem;
        font-weight: 600;
        color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
    }
`;

export const InclusionContent = styled.div`
    padding: 2rem 3rem;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 2.4rem;
    .inclusionCol{
        border-right: 0.1rem #ccc solid;
        padding-right: 1rem;
        h4{
            font-size: 1.4rem;
            line-height: 1.8rem;
            margin-bottom: 1.4rem;
            font-weight: 600;
            color: ${p => p.theme ? p.theme.colors.black.base : '#141823'};
        }
    }
    .inclusionCol:last-child{
        border-right: 0;
    }
`;
